import { Duration } from 'luxon';
import React from 'react';
import { Axis, Formatter } from '../../plot/components/Axis';
import { useStrip } from '../../plot/hooks/useStrip';
import { getExtent } from '../../plot/utils/scale';
import { MINUTE } from '../../utils/time';

const timestampToHourFormat: Formatter = (timestamp) => {
  const timeValue = timestamp.valueOf();
  const duration = Duration.fromMillis(timeValue);
  return duration.toFormat('hh:mm');
};

const timestampToMinuteFormat: Formatter = (timestamp) => {
  const timeValue = timestamp.valueOf();
  const duration = Duration.fromMillis(timeValue);
  return duration.toFormat('mm:ss');
};

const timestampToSecondFormat: Formatter = (timestamp) => {
  const timeValue = timestamp.valueOf();
  const duration = Duration.fromMillis(timeValue);
  return duration.toFormat('ss');
};

const pickFormatter = (duration: number): Formatter => {
  if (duration > 30 * MINUTE) {
    return timestampToHourFormat;
  }

  if (duration > 10 * MINUTE) {
    return timestampToMinuteFormat;
  }

  return timestampToSecondFormat;
};

export const ScatterBottomAxis: React.FC = () => {
  const { xScale } = useStrip();
  const duration = getExtent(xScale.domain());

  return (
    <g>
      <Axis
        scale={xScale}
        interval={duration / 3}
        formatter={pickFormatter(duration)}
      />
    </g>
  );
};
